import {Component, OnInit} from '@angular/core';
import {UiService} from '../../services/ui-service/ui.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  
 
  constructor(private UIservice: UiService) { }

  shallPlayVideo = (): boolean => {
    if (screen.width < 576) {
      return false;
    }
    return true;
  }

  ngOnInit() {
     
  }

  ngAfterViewInit(): void {
    try {
      let video = document.getElementsByTagName('video')[0];
      video.play = video.play;
      video.muted = !video.muted;
    } catch (e) {
  }
  }

}
